<template>
    <div>

        <config-main-title>
            Sinalizador de Atendimento
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir Sinalizador
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum Sinalizador identificado.'" 
                icon="fas fa-search"
                :action="'Incluir Sinalizador'" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <draggable v-model="lista" @start="drag=true" @end="drag=false; atualizarOrdem();" ghost-class="primary">
                    <li class="list-group-item d-flex justify-content-between hover-bg" 
                        class2="'list-group-item-' + dado.st_cor"
                        v-for="(dado, id) in lista" :key="id">
                        <span>
                            <i class="fa-2x fa-fw mr-3" :class="( dado.st_icon ? dado.st_icon : 'fas fa-flag' ) + ' text-' + dado.st_cor" aria-hidden="true"></i>
                            <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                                {{ dado.search }}
                            </a>
                            <span v-if="dado.fl_paciente" class="badge badge-secondary ml-2" data-toggle="tooltip" data-placement="top" title="Para Paciente"> 
                                Para Paciente
                            </span>
                        </span>
                        <span>
                            <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                                <input type="checkbox" class="custom-control-input" 
                                    :id="'ativo-' + id" 
                                    v-model="dado.fl_ativo" 
                                    @change="toggle(dado)">
                                <label class="custom-control-label" :for="'ativo-' + id"></label>
                            </div>
                        </span>
                    </li>
                </draggable>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id_sinalizador_atendimento ? '' : 'Novo' }}
                            Sinalizador de Atendimento
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    placeholder="Informe o título do sinalizador..."
                                    label="Tïtulo"
                                    :validate="validate"
                                    required
                                    v-model="item.st_sinalizador_atendimento" />
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col col-12">
                                <az-input
                                    type="checkbox-group"
                                    label="Outro Ícone"
                                    :validate="validate"
                                    v-model="item.fl_outro" />
                            </div>
                        </div>

                        <template v-if="item.fl_outro">

                            <div class="alert alert-info">
                                Informe um ícone da biblioteca <a href="https://fontawesome.com/search?q=smile&o=r&m=free" target="_blank">Font Awesome</a>.
                            </div>

                            <div class="row" v-if="item.fl_outro">
                                <div class="col col-12">
                                    <az-input
                                        label="Figura"
                                        placeholder="Informe..."
                                        :validate="validate"
                                        required
                                        v-model="item.st_icon"
                                        @input="verificar_texto(item)" />
                                </div>
                            </div>

                        </template>

                        <div class="row" v-else>
                            <div class="col col-12">
                                <az-input
                                    label="Figura"
                                    type="select"
                                    placeholder="Selecione..."
                                    :optionsList="[
                                        { id: 'fas fa-low-vision', search: 'Baixa Visão' },
                                        { id: 'fas fa-flag', search: 'Bandeira' }, 
                                        { id: 'fa-solid fa-baby', search: 'Bebê' }, 
                                        { id: 'fa-solid fa-person-breastfeeding', search: 'Bebê no Colo' }, 
                                        { id: 'fas fa-hiking', search: 'Bengala' }, 
                                        { id: 'fa-solid fa-person-cane', search: 'Bengala 2' }, 
                                        { id: 'fas fa-wheelchair', search: 'Cadeira de Rodas' },
                                        { id: 'fa-solid fa-baby-carriage', search: 'Carrinho de Bebê' }, 
                                        { id: 'far fa-angry', search: 'Chateado' },
                                        { id: 'fas fa-exclamation-circle', search: 'Círculo Exclamação' },
                                        { id: 'fa-solid fa-cross',  search: 'Cruz' },
                                        { id: 'fas fa-assistive-listening-systems', search: 'Deficiente Auditivo' },
                                        { id: 'fas fa-blind', search: 'Deficiente Visual' },
                                        { id: 'fas fa-dollar-sign', search: 'Dinheiro' },
                                        { id: 'fas fa-star', search: 'Estrela' },
                                        { id: 'fa-solid fa-spa', search: 'Flor' },
                                        { id: 'fas fa-pills', search: 'Medicamentos' }, 
                                        { id: 'fa-solid fa-person-pregnant', search: 'Mulher Grávia' }, 
                                        { id: 'fas fa-ban', search: 'Proibido' }, 
                                        { id: 'fas fa-puzzle-piece', search: 'Quebra-Cabeça' }, 
                                        { id: 'fas fa-x-ray', search: 'Raio-X' }, 
                                        { id: 'fas fa-clock', search: 'Relógio' },
                                        { id: 'fas fa-eye-slash', search: 'Sem Visão' },
                                        { id: 'far fa-smile', search: 'Smile' }, 
                                        { id: 'fas fa-head-side-cough', search: 'Tossindo' },    
                                        { id: 'fas fa-exclamation-triangle', search: 'Triângulo Exclamação' },
                                    ]"
                                    optionsData="id"
                                    :validate="validate"
                                    v-model="item.st_icon" />
                            </div>
                        </div>                        
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Cor"
                                    type="select"
                                    :optionsList="[
                                        { id: 'success', search: 'Verde' },
                                        { id: 'warning', search: 'Amarelo' },
                                        { id: 'danger', search: 'Vermelho' },
                                        { id: 'primary', search: 'Azul' },
                                        { id: 'dark', search: 'Preto' },
                                        { id: 'secondary', search: 'Cinza' },
                                        { id: 'info', search: 'Ciano' },
                                        { id: 'orange', search: 'Laranja' },
                                    ]"
                                    optionsData="id"
                                    :validate="validate"
                                    required
                                    v-model="item.st_cor" />
                            </div>
                        </div>                        
                        <div v-if="item.st_cor" class="my-3">
                            <i class="fa-2x" :class="( item.st_icon ? item.st_icon : 'fas fa-flag' ) + ' text-' + item.st_cor" aria-hidden="true"></i>
                        </div>

                        <div class="form-row mb-1">
                            <div class="col col-12" :class="item.fl_prioridade_recep ? 'col-md-6' : ''">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Prioridade Recepção"
                                    :edicao="false"
                                    v-model="item.fl_prioridade_recep" />
                            </div>
                            <div class="col col-12 col-md-6" v-if="item.fl_prioridade_recep">
                                <az-input
                                    sizing="sm"
                                    :compact="true"
                                    type="number"
                                    placeholder="Informar..."
                                    label="Ordem"
                                    v-model="item.in_ordem_recep" />
                            </div>
                        </div>

                        <div class="form-row mb-1">
                            <div class="col col-12" :class="item.fl_prioridade_atend ? 'col-md-6' : ''">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Prioridade Atendimento"
                                    v-model="item.fl_prioridade_atend" />
                            </div>
                            <div class="col col-12 col-md-6" v-if="item.fl_prioridade_atend">
                                <az-input
                                    sizing="sm"
                                    :compact="true"
                                    type="number"
                                    placeholder="Informar..."
                                    label="Ordem"
                                    v-model="item.in_ordem_atend" />
                            </div>
                        </div>

                        <div class="row mb-1">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Para Paciente"
                                    v-model="item.fl_paciente" />
                            </div>
                        </div>

                        <div class="row mb-1" v-if="!item.fl_paciente">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Obrigar Observação"
                                    v-model="item.fl_marcacao_obs_obrig" />
                            </div>
                        </div>

                        <div class="row" v-if="!item.fl_paciente">
                            <div class="col col-12">
                                <az-input
                                    label="Ação Especial"
                                    type="select"
                                    placeholder="Nenhuma"
                                    :optionsList="[
                                        { id: 'bloquear-chamada', search: 'Bloquear Chamada para Atendimento' },
                                        { id: 'bloquear-laudo', search: 'Bloquear Entrega de Resultado' },
                                        { id: 'bloquear-laudo-portal', search: 'Bloquear Entrega de Resultado no Portal' },
                                    ]"
                                    optionsData="id"
                                    :validate="validate"
                                    v-model="item.st_acao_especial" />
                            </div>
                        </div>  

                        <div class="row" v-else>
                            <div class="col col-12">
                                <az-input
                                    label="Ação Especial"
                                    type="select"
                                    placeholder="Nenhuma"
                                    :optionsList="[
                                        { id: 'bloquear-marcacao', search: 'Bloquear Marcação' },
                                        { id: 'bloquear-atendimento', search: 'Bloquear Atendimento' },
                                    ]"
                                    optionsData="id"
                                    :validate="validate"
                                    v-model="item.st_acao_especial" />
                            </div>
                        </div>  

                        <div class="row" v-if="item.st_acao_especial">
                            <div class="col col-12">
                                <az-input
                                    placeholder="Mensagem a ser exibida quando houver a ação esepcial..."
                                    label="Mensagem"
                                    type="textarea"
                                    rows="3"
                                    :validate="validate"
                                    required
                                    v-model="item.st_acao_mensagem" />
                            </div>
                        </div>                        

                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="sinalizadorAtendimento" :id="item.id_sinalizador_atendimento" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_sinalizador_atendimento ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import draggable from "vuedraggable";

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
        }
    },

    props: ['cadastro'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        draggable,
    },

    computed: { 
        lista_filtros: function () { 

            if ( !this.item ) 
                return [];

            return this.item.filtros.filter(item => !item.excluido);

        },

        lista: { 
            get() { 
                let pesquisar = this.search.trim();
                let parts = pesquisar.replace(' ','.*');
                let match = parts;
                let reg = new RegExp(match, 'i');

                return this.dados && this.dados.length ? 
                    this.dados.filter (item => { 
                        return ( this.viewMode == 'T' || item.fl_ativo ) && 
                            ( !this.search || reg.test(JSON.stringify(item)) );
                    }) : null;
            },

            set(value) { 
                this.$util.atualizar(this, { 
                    service: 'sinalizadores', 
                    func: 'ordem',
                    dados: {
                        lista: value
                    },
                    toast: true, 
                    reload: true, 
                });
            }
        },

    },

    methods: { 
        verificar_texto (item) { 
            if ( item.st_icon && item.st_icon.slice(0,3) == '<i ' && item.st_icon.slice(-4) == '</i>' ) { 
                let texto = item.st_icon.match(/"([^']+)"/);

                if ( texto.length == 2 ) { 
                    item.st_icon = texto[1];
                }
            }
        },

        atualizarOrdem() { 
            //
        },
        
        incluir () { 
            this.validate = false;

            let item = {
                id_sinalizador_atendimento: null, 
                st_sinalizador_atendimento: "", 
                st_cor: "success",
                st_icon: "fas fa-flag", 
                fl_ativo: true, 
                in_regra_ordem: 100, 
                fl_prioridade_recep: false,
                fl_prioridade_atend: false,
                in_ordem_recep: null,
                in_ordem_atend: null,
            };

            this.editar (item);
        },
        load () { 
            this.$util.load(this, { 
                service:'sinalizadores',
                func: 'index',
                parms: { 
                    cadastro: true, 
                }, 
            });
        },
        editar (item) { 
            this.validate = false;
            this.item = _.cloneDeep (item);

            $('#edicaoModal').modal('show');
        },
        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'sinalizadores',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'sinalizadores',
                dados: item,
            });

        },
    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Sinalizador de Atendimento", method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>